import styled from 'styled-components'
import { modalFontFamily } from '../PaymentDetailModal/PaymentDetailModal.styles'

export const PaymentMethodContainer = styled.div`
  background-color: #e8f4fc;
  border: 1px solid #dfe3e8;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
`

export const PaymentMethodHeader = styled.div`
  font-family: ${modalFontFamily};
  font-size: 16px;
  font-weight: 600;
  color: #111726;
  margin-bottom: 16px;
`

export const Divider = styled.div`
  height: 1px;
  background-color: #c3cfde;
  margin-bottom: 16px;
`

export const EditHeader = styled.div`
  font-family: ${modalFontFamily};
  font-size: 18px;
  font-weight: 500;
  color: #111726;
  margin-bottom: 16px;
`

export const MethodDisplayRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const MethodLabel = styled.span`
  font-family: ${modalFontFamily};
  font-size: 14px;
  font-weight: 500;
  color: #111726;
`

export const MethodValue = styled.span`
  font-family: ${modalFontFamily};
  font-size: 14px;
  font-weight: 400;
  color: #111726;
`

export const EditFormRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 16px;
`

export const FormField = styled.div`
  width: 30%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FormLabel = styled.label`
  font-family: ${modalFontFamily};
  font-size: 14px;
  font-weight: 500;
  color: #111726;
`

export const ActionButtonsRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const GenerateVcnLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: ${modalFontFamily};
  font-size: 14px;
  font-weight: 500;
  color: #111726;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    color: #01a0a8;
  }

  &:disabled {
    color: #8597b0;
    cursor: not-allowed;
  }
`

export const SubmitButtonsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
`

// VCN Details Table Styles
export const VcnDetailsContainer = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
`

export const VcnTable = styled.div`
  background: white;
  border-radius: 4px;
  overflow: hidden;
`

export const VcnTableRow = styled.div`
  display: flex;
  border-bottom: 1px solid #c3cfde;

  &:last-child {
    border-bottom: none;
  }
`

export const VcnTableLabel = styled.div`
  width: 180px;
  padding: 8px 12px;
  font-family: ${modalFontFamily};
  font-size: 13px;
  font-weight: 500;
  color: #111726;
  background: white;
  flex-shrink: 0;
`

export const VcnTableValue = styled.div`
  flex: 1;
  padding: 8px 12px;
  font-family: ${modalFontFamily};
  font-size: 13px;
  font-weight: 400;
  color: #111726;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const ShowHideButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-family: ${modalFontFamily};
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #40a9ff;
  }
`

export const CopyableText = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  &:hover {
    color: #1890ff;
  }
`

export const CopyIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: #8597b0;
  font-size: 14px;

  &:hover {
    color: #1890ff;
  }
`

export const ActionsRow = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 16px;
  align-items: flex-end;
`

export const ActionsField = styled.div`
  width: 293px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

// Status text colors
export const StatusText = styled.span<{ $status?: string }>`
  font-weight: 600;

  ${({ $status }) => {
    const normalizedStatus = $status?.toUpperCase() ?? ''
    switch (normalizedStatus) {
      case 'ACTIVE':
        return `color: #52c41a;`
      case 'SUSPENDED':
        return `color: #fa8c16;`
      case 'TERMINATED':
        return `color: #f5222d;`
      case 'PENDING':
        return `color: #1890ff;`
      default:
        return `color: #8c8c8c;`
    }
  }}
`
